import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { UrlConstants } from './url-constants';
import { SpinnerService } from '../services/spinner.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { Observable } from 'rxjs';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class GetPaymentService {
  data_11: Object;
  public subject = new Subject<any>();
  var = { data: false };
  user = new BehaviorSubject<any>({
    member_id: null,
    userType: null,
    isPrime: null,
  });
  cast = this.user.asObservable();
  videoTag = new BehaviorSubject<any>([]);
  videoTagCast = this.videoTag.asObservable();
  userDetails;

  constructor(
    private dataService: DataService,
    private urlConstants: UrlConstants,
    public http: HttpClient,
    private spinner: SpinnerService,
    private userService: UserService
  ) { }
  load(userName) {
    const params = [
      { param: '{object}', value: 'getPayment' },
      { param: '{id1}', value: userName },
      { param: '{id2}', value: 'accept_payment' },
    ];
    return this.dataService
      .getData(this.urlConstants.getUri(this.urlConstants.getList, params))
      .toPromise();
  }
  getPaymentList(userName) {
    const params = [
      { param: '{object}', value: 'getPaymentList' },
      { param: '{id1}', value: userName },
      { param: '{id2}', value: 'accept_payment' },
    ];
    return this.dataService
      .getData(this.urlConstants.getUri(this.urlConstants.getList, params))
      .toPromise();
  }
  async updatepayment(data) {
    const params = [{ param: '{object}', value: 'payments' }];
    const bodyObj = data;
    return this.dataService
      .postData(
        this.urlConstants.getUri(this.urlConstants.updateItem, params),
        JSON.stringify(bodyObj)
      )
      .toPromise();
  }
  async createPayment(data) {
    const params = [{ param: '{object}', value: 'payments' }];
    const bodyObj = data;
    return this.dataService
      .postData(
        this.urlConstants.getUri(this.urlConstants.createItem, params),
        JSON.stringify(bodyObj)
      )
      .toPromise();
  }
  async primePayment(data) {
    const params = [{ param: '{object}', value: 'user' }];
    const bodyObj = data;
    return this.dataService
      .postData(
        this.urlConstants.getUri(this.urlConstants.updateItem, params),
        JSON.stringify(bodyObj)
      )
      .toPromise();
  }

  async primeTableUpdate(data) {
    const params = [{ param: '{object}', value: 'primeuser' }];
    const bodyObj = data;
    return this.dataService
      .postData(
        this.urlConstants.getUri(this.urlConstants.updateItem, params),
        JSON.stringify(bodyObj)
      )
      .toPromise();
  }
  async getUserData(userName, given_name) {
    this.userService.getUser(false)
      .then(data => {
        let { member_id, userType, isPrime, prime } = data
        this.spinner.hide();
        this.user.next({
          member_id,
          userType,
          isPrime: isPrime,
          prime: prime
        });
      })
  }
}
